module.exports = __webpack_public_path__ + "img/fansere-logo.6f96385a.png";